import { FacilityHistoryPage } from '@/pages/facility/history';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/history-audit')({
	component: () => <FacilityHistoryPage type="audit" />,
});
